module.exports = __webpack_public_path__ + "assets/favicon-prod-8c2166.ico";